import { render, staticRenderFns } from "./SeatingDisplay.vue?vue&type=template&id=3a856bb2&scoped=true&"
import script from "./SeatingDisplay.vue?vue&type=script&lang=js&"
export * from "./SeatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a856bb2",
  null
  
)

export default component.exports